<div class="row mt-3 mb-3">
  <div class="col-12">
    <button [disabled]="disabled()" (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary" title="CTRL + I">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
    <button (click)="imprimir()" class="btn btn-outline-info float-right mr-4" style="font-size: 13px">Atestado
      forcedor</button>
      <button (click)="imprimir(null, true)" class="btn btn-outline-danger float-right mr-4"
        style="font-size: 13px">Atestado Limpo</button>
  </div>
</div>
<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th style="width: 80%" scope="col">Empresa</th>
      <th style="width: 30%" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 60%"><b>{{item.favorecido.cpf_cnpj}}</b> - {{item.favorecido.nome}}</td>
      <td *ngIf="item.editavel" style="width: 60%">
        <p-autoComplete id="rec" [(ngModel)]="item.favorecido" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="favorecidoAutoComplete.conversor"
          [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '100%' }">
          <ng-template let-favorecido pTemplate="item">
            {{favorecido.cpf_cnpj}} - {{favorecido.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td class="text-right" style="width: 30%">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" [disabled]="disabled()" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" [disabled]="disabled()" (click)="imprimir(item.favorecido)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/printer.png" alt="imprimir" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" [disabled]="disabled()" (click)="remover(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>